import React from 'react';

import './Footer.css';

export default class Footer extends React.Component {
  render() {
    return (
      <footer className="main-footer">
        <span>
          &copy; 2018 Building Energy, power efficientcy planner for building.
          All rights reserved. Ministry of energy.
        </span>
        <span className="pull-right">
          {process.env.REACT_APP_NAME}&nbsp;
          V. {process.env.REACT_APP_VERSION}&nbsp;
          ({process.env.REACT_APP_COMMIT})
        </span>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js